(() => {
  if (window.AsendIndividualSortInitialized) return;
  window.AsendIndividualSortInitialized = true;

  const closeSort = (sort) => {
    if (!sort) return;

    const trigger = sort.querySelector('[data-individual-sort-trigger]');
    const options = sort.querySelector('[data-individual-sort-options]');

    sort.classList.remove('is-open');
    trigger?.setAttribute('aria-expanded', 'false');
    if (options) options.hidden = true;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-individual-sort-trigger]');

    if (trigger) {
      const sort = trigger.closest('[data-individual-sort]');
      const options = sort?.querySelector('[data-individual-sort-options]');
      const willOpen = !sort?.classList.contains('is-open');

      document.querySelectorAll('[data-individual-sort].is-open').forEach(closeSort);

      if (willOpen && sort && options) {
        sort.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        options.hidden = false;
      }
      return;
    }

    const option = event.target.closest('[data-individual-sort-option]');

    if (option) {
      const sort = option.closest('[data-individual-sort]');
      const select = sort?.querySelector('.individual-sort__native');
      const label = sort?.querySelector('[data-individual-sort-label]');

      if (!sort || !select || select.value === option.dataset.value) {
        closeSort(sort);
        return;
      }

      select.value = option.dataset.value;
      if (label) label.textContent = option.textContent.trim();

      sort.querySelectorAll('[data-individual-sort-option]').forEach((item) => {
        const selected = item === option;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });

      closeSort(sort);
      select.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    document.querySelectorAll('[data-individual-sort].is-open').forEach(closeSort);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-individual-sort].is-open').forEach((sort) => {
      const trigger = sort.querySelector('[data-individual-sort-trigger]');
      closeSort(sort);
      trigger?.focus();
    });
  });
})();
